import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { ISchema } from "clients/LaForgeClient/validation-types/SchemaDefinition";

export const updateEmployeeRequirementUpdatedWebhook = (
  axios: IAxiosInstance
) => {
  return async ({
    url,
    testMode,
  }: ISchema["#/definitions/IUpdateEmployeeRequirementUpdatedWebhookBody"]) => {
    const response = await axios.noRetry.post<
      ISchema["#/definitions/IUpdateEmployeeRequirementUpdatedWebhookResponse"]
    >(`/api/updateEmployeeRequirementUpdatedWebhook`, {
      url,
      testMode,
    });

    const { data: responseData } = response;
    if (!responseData.success) {
      throw new Error(`Something went wrong`);
    }
    return responseData;
  };
};
